import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const initialState: Fields = {
  tagsToBeAdded: [],
  tagsToBeRemoved: [],
};

export interface Fields {
  tagsToBeAdded: string[];
  tagsToBeRemoved: string[];
}

interface HandleClickAction {
  tagId: string;
  initiallyEnabled: boolean;
}

const removeTagId = (baseList: string[], rmTagId: string) =>
  baseList.filter((listTagId) => listTagId != rmTagId);

const reducer = createSlice({
  name: 'asset-tags-patch-payload',
  initialState,
  reducers: {
    toggleStatus: (state, action: PayloadAction<HandleClickAction>) => {
      const { tagId, initiallyEnabled } = action.payload;
      if (initiallyEnabled) {
        if (state.tagsToBeRemoved.includes(tagId)) {
          state.tagsToBeRemoved = removeTagId(state.tagsToBeRemoved, tagId);
        } else {
          state.tagsToBeRemoved.push(tagId);
        }
      } else {
        if (state.tagsToBeAdded.includes(tagId)) {
          state.tagsToBeAdded = removeTagId(state.tagsToBeAdded, tagId);
        } else {
          state.tagsToBeAdded.push(tagId);
        }
      }
    },
    resetQueue: (state) => {
      state.tagsToBeAdded = [];
      state.tagsToBeRemoved = [];
    },
  },
});

export const { resetQueue, toggleStatus } = reducer.actions;

export default reducer.reducer;
